import React from 'react';
import { Button } from '@mui/material';
import { formatVolumeCell } from 'utils/helpers/format';
import LocationSelectionRadio from '../LocationSelectionRadio';

/**
 * Create column definitions for the locations grid
 *
 * @param {Object} params Configuration parameters
 * @param {string|number} params.selectedLocationIdn Currently selected location IDN
 * @param {Function} params.handleLocationSelect Callback for location selection
 * @param {Function} params.handleViewDetails Callback for viewing location details
 * @param {Object} params.safeReconsignmentState Current reconsignment state
 * @returns {Array} Column definitions for the grid
 */
const createLocationColumns = ({
  selectedLocationIdn,
  handleLocationSelect,
  handleViewDetails,
  safeReconsignmentState,
}) => [
  {
    field: 'selection',
    headerName: '',
    renderCell: params => (
      <LocationSelectionRadio
        locationIdn={params.row.locationIdn}
        onSelect={handleLocationSelect}
        selectedLocationIdn={selectedLocationIdn}
      />
    ),
    sortable: false,
    width: 70,
  },
  {
    field: 'locationIdn',
    headerName: 'Location ID',
    sortable: true,
    width: 120,
  },
  {
    field: 'locationName',
    headerName: 'Location Name',
    sortable: true,
    width: 200,
  },
  {
    field: 'inTransitVolume',
    headerName: 'Intransit Vol. (bbls)',
    sortable: true,
    type: 'number',
    valueFormatter: formatVolumeCell,
    width: 150,
  },
  {
    field: 'availableVolume',
    headerName: 'Available Vol. (bbls)',
    sortable: true,
    type: 'number',
    valueFormatter: formatVolumeCell,
    width: 150,
  },
  {
    field: 'totalVolume',
    headerName: 'Total Vol. (bbls)',
    sortable: true,
    type: 'number',
    valueFormatter: formatVolumeCell,
    width: 150,
  },
  {
    field: 'details',
    headerName: 'Current Details',
    renderCell: params => (
      <Button
        onClick={() => {
          handleViewDetails({
            ...params.row,
            inventoryOwner: safeReconsignmentState.inventoryOwner?.customerNameShort,
            product: safeReconsignmentState.product?.productName,
            rvp: safeReconsignmentState.rvp || 'Any',
            volume: params.row.totalVolume,
          });
        }}
        size="small"
        variant="outlined"
      >
        View Details
      </Button>
    ),
    sortable: false,
    width: 150,
  },
];

export default createLocationColumns;
